"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _search = require("modals/search");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _peopleGroup = babelHelpers.interopRequireDefault(require("block/peopleGroup"));

var _class, _descriptor, _temp;

var PeopleGroupMembersBlock =
/*#__PURE__*/
function (_PeopleGroupBlock) {
  babelHelpers.inherits(PeopleGroupMembersBlock, _PeopleGroupBlock);

  function PeopleGroupMembersBlock() {
    babelHelpers.classCallCheck(this, PeopleGroupMembersBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PeopleGroupMembersBlock).apply(this, arguments));
  }

  babelHelpers.createClass(PeopleGroupMembersBlock, null, [{
    key: "content",
    value: function content(block, page) {
      return block.people;
    }
  }]);
  return PeopleGroupMembersBlock;
}(_peopleGroup.default);

var PeopleGroupMembersTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PeopleGroupMembersTab, _Component);

  function PeopleGroupMembersTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PeopleGroupMembersTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PeopleGroupMembersTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "people", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PeopleGroupMembersTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(PeopleGroupMembersBlock, this.people);
    }
  }], [{
    key: "value",
    value: function value(object, page, tab) {
      if (tab.visible()) {
        var order = tab.order,
            title = tab.title,
            id = tab.id;
        var people = this.getPeople(object);

        if (r.people.length) {
          return {
            type: 'tab/PeopleGroupMembers',
            people: PeopleGroupMembersBlock.value({
              id: 'peopleLandingPageGroup',
              hideTitle: '1',
              displayMode: object.lpMemberListStyle,
              groupId: object.id,
              displayTitle: '',
              asCarousel: 0,
              people: people
            }.page),
            id: id,
            title: title,
            order: order
          };
        }
      }

      return null;
    }
  }, {
    key: "getPeople",
    value: function getPeople(object) {
      if (object.lpShowMembers == 'none') return [];
      if (object.lpMemberSortOrder == 'default') return object.records.slice();

      var pp = _exports.default.Channel.tools.accounts._php_tool.tool_getRecordIDs(object.id, object.lpShowAll != '1');

      var q = {
        id: pp,
        $order: 'asc'
      };

      switch (object.lpMemberSortOrder) {
        case 'reverseAlpha':
          q.$orderDir = 'desc';

        case 'alpha':
          q.$order = 'fullName';
          break;

        case 'newest':
          q.$orderDir = 'desc';

        case 'oldest':
          q.$order = 'created';
          break;
      }

      var people = _exports.default.Channel.tools.accounts.lwp('find', q).records;

      return new RecordList(_exports.default.Channel.tools.accounts, people).slice();
    }
  }]);
  return PeopleGroupMembersTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "people", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = PeopleGroupMembersTab;